module.exports = __webpack_public_path__ + "img/Icon-72@2x.36de11b5.png";